module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"donations":"Donations","total_donations":"Total Donations"},"id":{"donations":"Donasi","total_donations":"Jumlah Donasi"}}')
  delete Component.options._Ctor
}
